import { ChevronDown, Search } from "lucide-react";
import { useEffect, useRef, useState } from "react";

const MainAuditsLogs = () => {
  const menuRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(null);

  const data = [
    {
      id: 1,
      timeStamp: "2024-03-15 10:00 AM",
      adminUser: "Olivia Bennett",
      action: "Login",
      description: "User logged in",
      affected: "N/A",
      ipAddress: "192.168.1.100"
    },
    {
      id: 2,
      timeStamp: "2024-03-15 10:15 AM",
      adminUser: "Liam Harper",
      action: "Approval",
      description: "Approved document",
      affected: "Document XYZ",
      ipAddress: "192.168.1.101"
    },
    {
      id: 3,
      timeStamp: "2024-03-15 10:30 AM",
      adminUser: "Ava Coleman",
      action: "Edit",
      description: "Edited user profile",
      affected: "User: Sophia Clark",
      ipAddress: "192.168.1.102"
    },
    {
      id: 4,
      timeStamp: "2024-03-15 10:45 AM",
      adminUser: "Noah Foster",
      action: "Delete",
      description: "Deleted organization",
      affected: "Organization: Beta Inc.",
      ipAddress: "192.168.1.103"
    },
    {
      id: 5,
      timeStamp: "2024-03-15 10:45 AM",
      adminUser: "Isabella Reed",
      action: "Permission Change",
      description: "Changed user permissions",
      affected: "User: Daniel Hayes",
      ipAddress: "192.168.1.104"
    },
    {
      id: 6,
      timeStamp: "2024-03-15 11:15 AM",
      adminUser: "Jackson Hayes",
      action: "Document Upload",
      description: "Uploaded document",
      affected: "Document ABC",
      ipAddress: "192.168.1.105"
    },
    {
      id: 7,
      timeStamp: "2024-03-15 10:00 AM",
      adminUser: "Olivia Bennett",
      action: "Login",
      description: "User logged in",
      affected: "N/A",
      ipAddress: "192.168.1.100"
    },
    {
      id: 8,
      timeStamp: "2024-03-15 10:15 AM",
      adminUser: "Liam Harper",
      action: "Approval",
      description: "Approved document",
      affected: "Document XYZ",
      ipAddress: "192.168.1.101"
    },
    {
      id: 9,
      timeStamp: "2024-03-15 10:30 AM",
      adminUser: "Ava Coleman",
      action: "Edit",
      description: "Edited user profile",
      affected: "User: Sophia Clark",
      ipAddress: "192.168.1.102"
    },
    {
      id: 10,
      timeStamp: "2024-03-15 10:45 AM",
      adminUser: "Noah Foster",
      action: "Delete",
      description: "Deleted organization",
      affected: "Organization: Beta Inc.",
      ipAddress: "192.168.1.103"
    },
    {
      id: 11,
      timeStamp: "2024-03-15 10:45 AM",
      adminUser: "Isabella Reed",
      action: "Permission Change",
      description: "Changed user permissions",
      affected: "User: Daniel Hayes",
      ipAddress: "192.168.1.104"
    },
    {
      id: 12,
      timeStamp: "2024-03-15 11:15 AM",
      adminUser: "Jackson Hayes",
      action: "Document Upload",
      description: "Uploaded document",
      affected: "Document ABC",
      ipAddress: "192.168.1.105"
    },
  ]

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="my-6">
      <div className="">
        <h1 className="font-popinsSemiBold text-xl lg:text-2xl">Audit Logs</h1>
        <p className="font-popinsRegular text-black/50 text-sm">
          View system activity across all administrators and roles.
        </p>
      </div>
      <div className="">
        <div className="relative mt-7">
          <input
            type="text"
            placeholder="Search by name or email"
            class="peer w-full font-popinsMedium rounded-md border-2 border-border bg-[#F0F2F5] pl-9 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-[#3FC4E3] focus:shadow-[0_0_3px_#3FC4E3]"
          />
          <div className="absolute left-3 top-3">
            <Search size={18} color="#61708A" />
          </div>
        </div>
        <div className="flex space-x-4 mt-5" ref={menuRef}>
          {/* Location Menu */}
          <div className="relative">
            <button
              className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] shadow-sm hover:bg-gray-100 focus:outline-none flex items-center text-sm gap-x-2"
              onClick={() =>
                setOpenMenu(openMenu === "DateRange" ? null : "DateRange")
              }
            >
              Date Range
              <ChevronDown size={20} />
            </button>
            {openMenu === "DateRange" && (
              <ul className="absolute mt-1 w-56 bg-[#F0F2F5] text-[#121417] text-sm border rounded-md font-popinsRegular shadow-lg z-50">
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/1"
                  onClick={() => {
                    console.log("Location: New York");
                    setOpenMenu(null);
                  }}
                >
                  New York
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/1"
                  onClick={() => {
                    console.log("Location: Los Angeles");
                    setOpenMenu(null);
                  }}
                >
                  Los Angeles
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    console.log("Location: Chicago");
                    setOpenMenu(null);
                  }}
                >
                  Chicago
                </li>
              </ul>
            )}
          </div>

          {/* Services Menu */}
          <div className="relative">
            <button
              className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] flex items-center text-sm gap-x-2 shadow-sm hover:bg-gray-100 focus:outline-none"
              onClick={() =>
                setOpenMenu(openMenu === "ActionType" ? null : "ActionType")
              }
            >
              Action Type
              <ChevronDown size={20} />
            </button>
            {openMenu === "ActionType" && (
              <ul className="absolute mt-1 w-56 text-[#121417] bg-[#F0F2F5] font-popinsRegular text-sm rounded-md shadow-lg z-50">
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Cleaning");
                    setOpenMenu(null);
                  }}
                >
                  Cleaning
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Delivery");
                    setOpenMenu(null);
                  }}
                >
                  Delivery
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    console.log("Services Offered: Support");
                    setOpenMenu(null);
                  }}
                >
                  Support
                </li>
              </ul>
            )}
          </div>
          <div className="relative">
            <button
              className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] flex items-center text-sm gap-x-2 shadow-sm hover:bg-gray-100 focus:outline-none"
              onClick={() =>
                setOpenMenu(openMenu === "Performed" ? null : "Performed")
              }
            >
              Performed By
              <ChevronDown size={20} />
            </button>
            {openMenu === "Performed" && (
              <ul className="absolute mt-1 w-56 text-[#121417] bg-[#F0F2F5] font-popinsRegular text-sm rounded-md shadow-lg z-50">
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Cleaning");
                    setOpenMenu(null);
                  }}
                >
                  Cleaning
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Delivery");
                    setOpenMenu(null);
                  }}
                >
                  Delivery
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    console.log("Services Offered: Support");
                    setOpenMenu(null);
                  }}
                >
                  Support
                </li>
              </ul>
            )}
          </div>
          <div className="relative">
            <button
              className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] flex items-center text-sm gap-x-2 shadow-sm hover:bg-gray-100 focus:outline-none"
              onClick={() =>
                setOpenMenu(
                  openMenu === "UserOrganization" ? null : "UserOrganization"
                )
              }
            >
              Affected User/Organization
              <ChevronDown size={20} />
            </button>
            {openMenu === "UserOrganization" && (
              <ul className="absolute mt-1 w-56 text-[#121417] bg-[#F0F2F5] font-popinsRegular text-sm rounded-md shadow-lg z-50">
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Cleaning");
                    setOpenMenu(null);
                  }}
                >
                  Cleaning
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Delivery");
                    setOpenMenu(null);
                  }}
                >
                  Delivery
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    console.log("Services Offered: Support");
                    setOpenMenu(null);
                  }}
                >
                  Support
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mt-8">
        {[
          { label: "Total Actions", value: '1,234', percent: '+10' },
          { label: "Most Common Action", value: 'Edit', percent: '0' },
          { label: "Most Active Admin", value: 'Ethan Carter', percent: '0' },
          { label: "Average Actions per Admin", value: '123', percent: '-5' },
        ].map((item, i) => (
          <div
            key={i}
            className="bg-white px-5 py-8 rounded-xl border shadow-md flex flex-col items-start"
          >
            <p className="font-popinsMedium text-base">{item.label}</p>
            <p className="text-2xl font-popinsSemiBold my-2">{item.value}</p>
            <p className={`text-base font-popinsRegular ${item.label === 'Total Actions' ? 'text-[#088738]' : item.label === 'Average Actions per Admin' ? 'text-[#E83808]' :  'text-black/50'}`}>{item.percent}%</p>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-lg shadow border border-border overflow-hidden mt-8">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="w-[20%] px-3 py-3 text-left text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Timestamp
                </th>
                <th className="w-[20%] py-3 text-center text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Admin User
                </th>
                <th className="w-[10%] py-3 text-center text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Action Type
                </th>
                <th className="w-[20%] py-3 text-center text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Description
                </th>
                <th className="w-[10%] py-3 text-center text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Affected User/Org
                </th>
                <th className="w-[20%] py-3 text-center text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  IP Address
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.map((item) => (
                <tr
                  key={item.id}
                  className="hover:bg-gray-50 transition-colors"
                >
                  <td className="px-3 py-4 whitespace-nowrap">
                    <div className="text-sm font-popinsMedium text-gray-900">
                      {item.timeStamp}
                    </div>
                  </td>
                  <td className="px-3 py-4 text-center text-sm font-popinsMedium text-black/50">
                      {item.adminUser}
                  </td>
                  <td className="py-4 whitespace-nowrap flex justify-center">
                    <span className="px-5 py-2 inline-flex text-xs leading-5 font-popinsSemiBold rounded-md bg-gray-200 ">
                      {item.action}
                    </span>
                  </td>
                  <td className="px-3 py-4 text-center text-black/50">
                    {item.description}
                  </td>
                  <td className="py-4 text-center">
                    {item.affected}
                  </td>
                  <td className="text-center">
                    {item.ipAddress}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* <div className="md:hidden space-y-3">
            {role.map((row) => (
              <div
                key={row.id}
                className="bg-white/80 p-4 rounded-xl shadow-sm border border-border hover:shadow-md transition-shadow duration-200 cursor-pointer"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="w-full">
                    <div className="flex items-center !justify-between gap-2">
                      <div>
                        <p className="font-popinsSemiBold text-base">Name</p>
                        <p className="font-popinsMedium text-sm text-black/50">
                          {row.name}
                        </p>
                      </div>
                      <div>
                        <span
                          className={`flex justify-center items-center py-[10px] rounded-lg text-sm font-popinsMedium ${statusClasses(
                            role.status
                          )}`}
                        >
                          <span
                            className="w-2 h-2 rounded-full"
                            aria-hidden
                          ></span>
                          {role.status}
                        </span>
                      </div>
                    </div>
                    <div className="mt-3">
                      <div className="text-sm flex gap-2 items-center">
                        <p className="font-popinsSemiBold text-base">email:</p>
                        <p className="text-black/50 font-popinsMedium">
                          {row.email}
                        </p>
                      </div>
                      <div className="text-sm mt-2 flex gap-2 items-center">
                        <p className="font-popinsSemiBold text-base">
                          Role Type:
                        </p>
                        <p className="text-black/50 font-popinsMedium">
                          {row.roleType}
                        </p>
                      </div>
                      <div className="text-sm mt-2 flex gap-2 items-center">
                        <p className="font-popinsSemiBold text-base">
                          Assigned Permissions:
                        </p>
                        <p className="text-black/50 font-popinsMedium">
                          {row.permission}
                        </p>
                      </div>
                      <div className="text-sm mt-2 flex gap-2 items-center">
                        <p className="font-popinsSemiBold text-base">
                          Actions:
                        </p>
                        <div className="flex gap-x-3 items-center justify-center w-full">
                          <button
                            title="Edit"
                            className="bg-blue-100 p-2 rounded-md"
                          >
                            <Pencil size={16} className="text-blue-600" />
                          </button>
                          <button
                            title="Suspend"
                            className="bg-yellow-100 p-2 rounded-md"
                          >
                            <Ban size={16} className="text-yellow-600" />
                          </button>
                          <button
                            title="Delete"
                            className="bg-red-100 p-2 rounded-md"
                          >
                            <Trash2 size={16} className="text-red-600" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </div>
      <div className="flex justify-end gap-x-4 mt-5">
        <button className="bg-gray-200 text-black px-5 py-2 font-popinsMedium rounded-md text-sm hover:bg-gray-100 transition">
            Export
          </button>
        <button
          type="submit"
          className="relative overflow-hidden py-[10px] bg-themeColor text-white font-popinsSemiBold text-sm px-5 rounded-md shadow-lg
           transform transition duration-300 ease-in-out
           hover:bg-[#3FC4E3] hover:scale-105 hover:shadow-[0_0_20px_rgba(63,196,227,0.6)] 
           active:scale-95 active:shadow-inner focus:outline-none
           disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
        >
          <span>Download All Logs</span>
          <span className="absolute inset-0 rounded-full bg-white opacity-0 active:opacity-10 transition-opacity duration-300"></span>
        </button>
      </div>
    </div>
  );
};

export default MainAuditsLogs;
